// react
import * as React from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

// material ui
import { Box, IconButton, Tooltip } from '@mui/material';

interface RowActionsProps {
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
}

const RowActions = ({
  onView,
  onEdit,
  onDelete,
  disabled = false,
}: RowActionsProps) => {
  const stop = (handler: () => void) => (event: React.MouseEvent) => {
    event.stopPropagation();
    handler();
  };

  const { t } = useTranslation('common');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {onView && (
        <Tooltip
          disableInteractive
          title={t('actions.view') ?? 'View'}
          placement="top"
        >
          <span>
            <IconButton
              size="small"
              onClick={stop(onView)}
              disabled={disabled}
              data-testid="row-action-view"
              sx={{ borderRadius: 2 }}
            >
              <SearchRoundedIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}

      {onEdit && (
        <Tooltip
          disableInteractive
          title={t('actions.edit') ?? 'Edit'}
          placement="top"
        >
          <span>
            <IconButton
              size="small"
              onClick={stop(onEdit)}
              disabled={disabled}
              data-testid="row-action-edit"
              sx={{ borderRadius: 2 }}
            >
              <EditRoundedIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}

      {onDelete && (
        <Tooltip
          disableInteractive
          title={t('actions.delete') ?? 'Delete'}
          placement="top"
        >
          <span>
            <IconButton
              size="small"
              onClick={stop(onDelete)}
              disabled={disabled}
              data-testid="row-action-delete"
              sx={{ borderRadius: 2, ':hover': { color: 'error.main' } }}
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};

export default RowActions;
